import React from 'react';
import { NextPage } from 'next';
import EducationQualityManagementSystemTemplate from '@components/EducationQualityManagementSystem/EducationQualityManagementSystem';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import useTranslation from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';

interface IEducationQualityManagementSystem {}

const EducationQualityManagementSystem: NextPage<IEducationQualityManagementSystem> = () => {
    const { t } = useTranslation();

    return (
        <>
            <HeaderTemplate />
            <ContentTemplate withPadding>
                <EducationQualityManagementSystemTemplate />
            </ContentTemplate>
            <FooterTemplate />
        </>
    );
};

export default EducationQualityManagementSystem;
